import React from 'react';
import styles from './default-desktop-layout.scss';

type Props = {
  children?: React.ReactNode;
};

const DefaultDesktopLayout = ({ children }: Props) => (
  <div className={styles.container}>
    <div className={styles.content}>{children}</div>
  </div>
);

export default DefaultDesktopLayout;
